import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SHOULD_PRESET_COMPANY_CLAIMGROUP_FORM_FILEDS } from '@rd-web-markets/market/dist/constants';
const defaultMd = {
  label: {
    offset: 0,
    span: 7
  },
  field: {
    offset: 0,
    span: 5
  }
};
const YesOrNoFormField = _ref => {
  let {
    labelText,
    disabled,
    formName,
    trueLabel = "Yes",
    falseLabel = "No",
    checkedField,
    onChange,
    onChangeParams,
    md = defaultMd
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: md.label
  }, labelText), /*#__PURE__*/React.createElement(Col, {
    md: md.field
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "radio",
    inline: true,
    disabled: disabled,
    label: t(trueLabel),
    name: formName,
    value: true,
    checked: checkedField === true,
    onChange: e => onChangeParams ? onChange(e, ...onChangeParams) : onChange(e),
    "data-testid": "trueButton"
  }), /*#__PURE__*/React.createElement(Form.Check, {
    type: "radio",
    inline: true,
    disabled: disabled,
    label: t(falseLabel),
    value: "false",
    name: formName,
    checked: SHOULD_PRESET_COMPANY_CLAIMGROUP_FORM_FILEDS ? checkedField === false || checkedField === undefined : checkedField === false,
    onChange: e => onChangeParams ? onChange(e, ...onChangeParams) : onChange(e),
    "data-testid": "falseButton"
  })));
};
export default YesOrNoFormField;